// De schakelaar "Bekijk als" in de kopbalk (pilot 26-10, baan 2B).
//
// Alleen voor beheer (`mij.beheerder`, ook in de stand AM/BP waar `isAdmin`
// effectief false is). Beheer kiest een rol (Beheer, AM, BP) en een
// propositie en ziet de schermen dan precies zoals die rol: de startpropositie,
// de navigatie, de stoel in het Plan, en géén interne testdata. Er is geen
// identiteitswissel: de sessie blijft die van beheer en de dienst controleert
// zelf of de vrager beheer is.

import type { Mij } from "../contracts";
import { type BekijkAlsRol, ROL_WOORD, bekijkAls, zetBekijkAls } from "../lib/bekijkAls";
import { color, radius, size, weight } from "../tokens";

const ROLLEN: BekijkAlsRol[] = ["beheer", "am", "bp"];

const veld = {
  font: "inherit",
  fontSize: size.label,
  color: color.body,
  background: color.surface,
  border: `1px solid ${color.border}`,
  borderRadius: radius.input,
  padding: "3px 6px",
  maxWidth: 170,
} as const;

export function BekijkAls({ mij }: { mij: Mij | null }) {
  if (!mij?.beheerder) return null;
  const stand = bekijkAls();
  const opties = mij.bekijkAlsOpties ?? [];
  const rol: BekijkAlsRol = stand?.rol ?? "beheer";
  const propositie = stand?.propositie ?? "";
  const actief = stand !== null;

  const zet = (r: BekijkAlsRol, p: string) => {
    // AM en BP horen bij een propositie: zonder keuze de eerste uit de lijst.
    const prop = p || (r === "beheer" ? "" : (opties[0]?.key ?? ""));
    if (r === "beheer" && !prop) zetBekijkAls(null);
    else zetBekijkAls({ rol: r, propositie: prop || null });
  };

  return (
    <div
      role="group"
      aria-label="Bekijk als"
      title="Zie de schermen zoals een accountmanager of opleidingsmanager ze ziet. Je blijft ingelogd als beheer."
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        flexWrap: "wrap",
        padding: "3px 8px",
        borderRadius: radius.input,
        background: actief ? color.accentAmberBg : "transparent",
        border: `1px solid ${actief ? color.accentAmber : "transparent"}`,
      }}
    >
      <span style={{ fontSize: size.label, color: actief ? color.accentAmber : color.faint, fontWeight: weight.medium }}>
        Bekijk als
      </span>
      <select aria-label="Rol" value={rol} onChange={(e) => zet(e.target.value as BekijkAlsRol, propositie)} style={veld}>
        {ROLLEN.map((r) => (
          <option key={r} value={r}>
            {ROL_WOORD[r]}
          </option>
        ))}
      </select>
      <select aria-label="Propositie" value={propositie} onChange={(e) => zet(rol, e.target.value)} style={veld}>
        {rol === "beheer" && <option value="">Eigen stand</option>}
        {opties.map((o) => (
          <option key={o.key} value={o.key}>
            {o.naam}
          </option>
        ))}
      </select>
      {actief && (
        <button
          type="button"
          onClick={() => zetBekijkAls(null)}
          style={{ ...veld, cursor: "pointer", color: color.accentAmber, borderColor: color.accentAmber }}
        >
          Terug naar beheer
        </button>
      )}
    </div>
  );
}
